module.exports = __webpack_public_path__ + "img/chevron-down.f20e6095.svg";